
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../state';
import { postPasswordChange } from '../../client/password';
import PasswordField from '../../fields/PasswordField.vue';

@Component({
    components: { PasswordField, ValidationObserver },
})
export default class PasswordChange extends Vue {
    shared = sharedState;
    local = {
        oldPassword: '',
        password: '',
        password2: '',
    };

    async submit() {
        if (this.local.password == this.local.password2) {
            await this.changePassword();
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordsDoNotMatch').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }

    async changePassword() {
        if (await postPasswordChange(this.local.password!!, this.local.oldPassword!!)) {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChanged').toString(),
                type: 'is-success',
                position: 'is-top',
            });
            this.local.oldPassword = '';
            this.local.password = '';
            this.local.password2 = '';
            (this.$refs.observer as any).reset();
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChangeFailed').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }
}
